import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, Slide } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate } from "react-router-dom";
import {
  CHAT_WORKSPACE_PATH,
} from "../../utils/appNavigation";
import { trackFrontendEvent } from "../../utils/tracking";
import {
  CLASSIC_WORKSPACE_REMINDER_KEY,
  localCalendarDay,
  millisecondsUntilNextLocalDay,
  shouldShowClassicWorkspaceReminder,
} from "./classicWorkspaceReminder";

const shouldShowNotice = () => {
  try {
    return shouldShowClassicWorkspaceReminder({
      dismissedOn: window.localStorage.getItem(
        CLASSIC_WORKSPACE_REMINDER_KEY,
      ),
    });
  } catch (_error) {
    return shouldShowClassicWorkspaceReminder();
  }
};

const ClassicWorkspaceNotice = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(shouldShowNotice);

  useEffect(() => {
    let timeoutId;
    const scheduleNextDay = () => {
      timeoutId = window.setTimeout(() => {
        setVisible(shouldShowNotice());
        scheduleNextDay();
      }, millisecondsUntilNextLocalDay() + 100);
    };

    scheduleNextDay();
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(
        CLASSIC_WORKSPACE_REMINDER_KEY,
        localCalendarDay(),
      );
    } catch (_error) {
      // Dismissal can remain session-only when storage is unavailable.
    }
    setVisible(false);
  };

  return (
    <Slide direction="down" in={visible} mountOnEnter unmountOnExit timeout={260}>
      <Box
        data-classic-workspace-notice
        role="status"
        sx={{
          position: "fixed",
          zIndex: 1250,
          top: { xs: 52, sm: 58 },
          left: 12,
          right: 12,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: { xs: "wrap", sm: "nowrap" },
          columnGap: 0.7,
          rowGap: 0.25,
          width: "fit-content",
          maxWidth: "calc(100vw - 24px)",
          px: 1.2,
          py: 0.65,
          border: "1px solid rgba(148, 163, 184, 0.35)",
          borderRadius: "10px",
          backgroundColor: "rgba(24, 24, 27, 0.96)",
          color: "#f4f4f5",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
          fontSize: 13,
          textAlign: "center",
        }}
      >
        <Box component="span">
          Incite 2.0 is ready. Chat beside live charts, your watchlist, research,
          and tasks.
        </Box>
        <Button
          size="small"
          onClick={() => {
            trackFrontendEvent("workspace_default_opened_from_classic", {
              source_surface: "classic_chat_daily_reminder",
            });
            navigate(CHAT_WORKSPACE_PATH);
          }}
          sx={{
            color: "#c4b5fd",
            minWidth: 0,
            px: 0.6,
            textTransform: "none",
            whiteSpace: "nowrap",
          }}
        >
          Open Incite 2.0
        </Button>
        <IconButton
          size="small"
          aria-label="Dismiss Incite 2.0 reminder for today"
          onClick={dismiss}
          sx={{ color: "#a1a1aa", p: 0.35 }}
        >
          <CloseRoundedIcon sx={{ fontSize: 17 }} />
        </IconButton>
      </Box>
    </Slide>
  );
};

export default ClassicWorkspaceNotice;
